export const BRAND_PROPERTIES = {
    INSTANT_GAMES_ENABLED: "INSTANT_GAMES_ENABLED",
    PREMIUM_ENABLED: "PREMIUM_ENABLED"
}